// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + (chunkId === 396 ? "vendor-monaco" : chunkId) + "." + {"396":"623d58a257ee84cd5269","932":"9665b4f3e270d5828c42"}[chunkId] + ".hashedasset.js";
};